/** @jsx jsx */
import { useState } from 'react'
import { css, jsx } from '@emotion/core'
import { CssTooltip } from '@livechat/design-system'
import infoIcon from '../assets/icons/info-round.svg'

const labelCss = css`
  display: block;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .info {
    > img {
      width: 20px;
      margin-left: 5px;
      margin-bottom: -4px;
      cursor: pointer;
    }
  }
`

const Heading = ({ label, info }) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)

  return (
    <span css={labelCss}>
      <span>{label}</span>
      {info && (
        <div
          className="info"
          style={{ display: 'inline-block', position: 'relative' }}
        >
          <img
            src={infoIcon}
            alt="info"
            onMouseEnter={() => setIsTooltipOpen(true)}
            onMouseLeave={() => setIsTooltipOpen(false)}
          />
          <CssTooltip
            placement="bottom"
            isVisible={isTooltipOpen}
            width="200px"
            zIndex={100}
          >
            <div
              css={css`
                max-width: 200px;
                text-align: center;
              `}
            >
              {info}
            </div>
          </CssTooltip>
        </div>
      )}
    </span>
  )
}

export default Heading
